export default __webpack_public_path__ + "static/media/p3.be9611a6.jpg";